<template>
  <div>
    <v-btn
        v-for="action in props.additionalActions"
        flat
        color="primary"
        density="comfortable"
        @click="callAction(action?.action)"
    >
      {{ action?.actionName }}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { useLibraryStore } from "@/stores/library";
import AdditionalAction from "@/interfaces/AdditionalAction";

const props = defineProps({
  procedure: { type: Object },
  additionalActions: Array<AdditionalAction>
})

const libraryStore = useLibraryStore();

const callAction = (code :string) => {
  libraryStore.callActionByCode(code, { procedure: props.procedure });
};
</script>

<style scoped lang="scss">
</style>
